class FadeElement {
  constructor(element) {
    this.element = element;
    this.isFadingIn = false;
    this.animationFrameId = null;
  }

  fadeIn(time) {
    const { element } = this;
    const duration = time || 1000; // 預設動畫時間為1秒

    if (this.animationFrameId || element.style.opacity === '1') {
      return;
    }

    element.style.display = 'block';
    element.style.opacity = Number.parseFloat(element.style.opacity) || 0;

    const startTime = performance.now();

    const fadeInAnimation = (timestamp) => {
      const progress = Math.min(1, (timestamp - startTime) / duration);

      element.style.opacity = progress;

      if (progress < 1) {
        this.animationFrameId = requestAnimationFrame(fadeInAnimation);
      }
      else {
        this.animationFrameId = null;
        this.isFadingIn = true;
      }
    };

    this.animationFrameId = requestAnimationFrame(fadeInAnimation);
  }

  fadeOut(time) {
    const { element } = this;
    const duration = time || 1000; // 預設動畫時間為1秒

    if (this.animationFrameId || element.style.opacity === '0') {
      return;
    }

    const startTime = performance.now();

    const fadeOutAnimation = (timestamp) => {
      const progress = Math.min(1, (timestamp - startTime) / duration);

      element.style.opacity = 1 - progress;

      if (progress < 1) {
        this.animationFrameId = requestAnimationFrame(fadeOutAnimation);
      }
      else {
        this.animationFrameId = null;
        element.style.display = 'none';
        this.isFadingIn = false;
      }
    };

    this.animationFrameId = requestAnimationFrame(fadeOutAnimation);
  }

  stopAnimation() {
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
      this.animationFrameId = null;
    }
  }
}

export { FadeElement };
